// utils/InCallNotifyBus.ts
type InCallQueueEvent = {
  requestId: string;
  patientId: string;
  patientName: string;
  deviceName: string;
  isEmergency: boolean;
  requestTime: string; // ISO
  deviceOffset?: number;
  timezoneString?: string;
  numRequests?: number;
};

type Listener = (evt: InCallQueueEvent) => void;
type Remove = () => void;

class InCallNotifyBus {
  private listeners = new Set<Listener>();

  publish(evt: InCallQueueEvent) {
    this.listeners.forEach(l => {
      try {
        l(evt);
      } catch (e) {
        /* no-op */
      }
    });
  }

  subscribe(listener: Listener): Remove {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  }
}

export const inCallNotifyBus = new InCallNotifyBus();
export type { InCallQueueEvent, Remove };
